import https from "../../axios";
import { BaseResponse } from "../../db/response";
import normalizeBaseResponse from "../../utils/responseHandler";
import errorHandler from "../../utils/errorHandler";

interface ResetPasswordParams {
  emailOrPhone: string;
  newPassword: string;
  confirmPassword: string;
}
export const resetPassword = async (
  params: ResetPasswordParams,
): Promise<BaseResponse> => {
  try {
    const response = await https.post("/v1/auth/reset-password", params);
    return normalizeBaseResponse(response.data);
  } catch (error) {
    return errorHandler(error);
  }
};
